export const animatetableBg = {
  hidden: { opacity: 0, scale: 0, heigth: 0, width: 0 },
  visible: {},
};

export const animateImg1 = {
  hidden: { opacity: 0, scale: 1.5, x: 400, y: 320 },
  visible: {
    opacity: 1,
    scale: 1,
    x: 0,
    y: 0,
    transition: { delay: 0.8 },
  },
};
export const animateImg2 = {
  hidden: { scale: 0.5, y: 480 },
  visible: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: { delay: 1.4 },
  },
};
export const animateImg3 = {
  hidden: { scale: 1.5, x: -400, y: 480 },
  visible: {
    opacity: 1,
    scale: 1,
    x: 0,
    y: 0,
    transition: { duration: 0.5, delay: 0.8, delayChildren: 1.2 },
  },
};
export const animateImg4 = {
  hidden: { scale: 1.5, x: 400 },
  visible: {
    opacity: 1,
    scale: 1,
    x: 0,
    transition: { delay: 1 },
  },
};
export const animateImg5 = {
  hidden: { x: 280, y: 160 },
  visible: {
    opacity: 1,
    rotate: [-360, -270, -180, -90, 0],
    x: 0,
    y: 0,
    transition: { delay: 1.2 },
  },
};

export const animateImg6 = {
  hidden: { opacity: 0, y: -160 },
  visible: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: { delay: 1.5 },
  },
};
export const animateImg7 = {
  hidden: { opacity: 0, y: 320, x: 275 },
  visible: {
    opacity: 1,
    scale: 1,
    y: 0,
    x: 0,
    transition: { delay: 1.3 },
  },
};
export const animateImg8 = {
  hidden: { opacity: 0, y: 320, x: -280 },
  visible: {
    opacity: 1,
    scale: 1,
    y: 0,
    x: 0,
    transition: { delay: 1.3 },
  },
};
export const animateImg9 = {
  hidden: { opacity: 0, y: -160, x: -400 },
  visible: {
    opacity: 1,
    scale: 1,
    y: 0,
    x: 0,
    transition: { delay: 1.15 },
  },
};
export const animateImg10 = {
  hidden: { opacity: 0, scale: 0.8, y: -480, x: 280 },
  visible: {
    opacity: 1,
    scale: 1,
    y: 0,
    x: 0,
    transition: { delay: 0.35 },
  },
};
export const animateImg11 = {
  hidden: { opacity: 0, y: -160, x: -275 },
  visible: {
    opacity: 1,
    scale: 1,
    y: 0,
    x: 0,
    transition: { delay: 1.15 },
  },
};
export const animateImg12 = {
  hidden: { opacity: 0, scale: 1.2, y: -320, x: -275 },
  visible: {
    opacity: 1,
    scale: 1,
    y: 0,
    x: 0,
    transition: { delay: 1.25 },
  },
};
export const animateImg13 = {
  hidden: { opacity: 0, y: -480, x: -593 },
  visible: {
    opacity: 1,
    scale: 1,
    y: 0,
    x: 0,
    transition: { delay: 1.5 },
  },
};
export const animateImg14 = {
  hidden: { opacity: 0, scale: 0.7, x: 600 },
  visible: {
    opacity: 1,
    scale: 1,
    x: 0,
    transition: { delay: 0.85 },
  },
};
export const animateImg15 = {
  hidden: { opacity: 0, x: 200 },
  visible: {
    opacity: 1,
    scale: 1,
    x: 0,
    transition: { delay: 1.5 },
  },
};
export const animateImg16 = {
  hidden: { opacity: 0, x: -200 },
  visible: {
    opacity: 1,
    scale: 1,
    x: 0,
    transition: { delay: 1.5 },
  },
};
export const animateImg17 = {
  hidden: { opacity: 0, x: -200, y: -160 },
  visible: {
    opacity: 1,
    scale: 1,
    y: 0,
    x: 0,
    transition: { delay: 1.5 },
  },
};

export const animatebuyCoffee = {
  animate: {
    rotate: [10, -10, 10, -10, 10, -10, 0],
  },
};
